(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("wixReactDealerViewer", ["react"], factory);
	else if(typeof exports === 'object')
		exports["wixReactDealerViewer"] = factory(require("react"));
	else
		root["wixReactDealerViewer"] = factory(root["React"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 